<template>
  <div class="b-tabs-wrap d-xl-flex">
    <VTabs
      class="b-tabs"
      v-model="tab"
      background-color="transparent"
      color="dark"
      slider-size="4"
      slider-color="primary"
      :vertical="$vuetify.breakpoint.xlOnly"
      hide-slider
    >
      <VTab class="tab-name mr-4 mr-lg-6">
        {{ $t("accountInfo") }}
      </VTab>
      <VTab class="tab-name mr-4 mr-lg-6">
        {{ $t("settings") }}
      </VTab>
    </VTabs>
    <VTabsItems v-model="tab" class="flex-grow-1" touchless>
      <VTabItem class="account-card">
        <AccountInfo :user="user" />
      </VTabItem>
      <VTabItem class="account-card">
        <AccountSettings :user="user" />
      </VTabItem>
    </VTabsItems>
  </div>
</template>

<script>
import { computed, toRefs } from '@vue/composition-api';
import AccountInfo from '@/components/Account/AccountInfo.vue';
import { accountTabs, settingsTabs } from '@/enums';
import AccountSettings from './AccountSettings/AccountSettings.vue';

export default {
  name: 'Account',
  components: { AccountInfo, AccountSettings },
  props: {
    user: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      default: accountTabs.INFO,
    },
  },
  setup(props, { root }) {
    const { type } = toRefs(props);
    const tabList = [accountTabs.INFO, accountTabs.SETTINGS];

    const tab = computed({
      get: () => {
        const index = tabList.indexOf(type.value);
        return index === -1 ? 0 : index;
      },
      set: (index) => {
        const newType = tabList[index];
        if (newType !== type.value) {
          root.$router.replace({
            name: 'settings',
            params: {
              type: settingsTabs.ACCOUNT,
              addType: newType,
            },
          });
        }
      },
    });

    return { tab };
  },
};
</script>

<style lang="scss" scoped>
.tab-name {
  font-size: 1rem;
  letter-spacing: 0;
  line-height: 1.25;
}
@media #{map-get($display-breakpoints, 'xl-only')} {
  .b-tabs-wrap {
    padding-top: 2.5rem;
  }
  .b-tabs {
    min-width: 15rem;
    max-width: 15rem;
    margin-right: 1.25rem;
  }
  .tab-name {
    justify-content: left;
    border-bottom: 1px solid rgba(196, 196, 196, 0.5);
  }
}

::v-deep .v-tab--active {
  color: #0A82D9;
}
</style>

<i18n locale="en" lang="yaml">
  accountInfo: Account Information
  settings: Settings
</i18n>

<i18n locale="ru" lang="yaml">
  accountInfo: Информация об аккаунте
  settings: Настройки
</i18n>
